export default "__VITE_PUBLIC_ASSET__e742363e__"